import InputDrop from "../../InputDrop";
import React from "react";
import Modal from "components/Modal";
import cls from "./modal.module.scss";
import { Button } from "@duik/it";
import className from "classnames";
export const AssessmentUpload = ({ handleClose, isOpen, onClickExport }) => {
  const [format, setFormat] = React.useState("CSV");
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      className={cls.modalWrapper}
    >
      <h2>Export implants and disposables list</h2>
      <div>
        <InputDrop
          label="EXPORT FORMAT"
          handleChange={(e) => {
            setFormat(e.label);
          }}
          name="format"
          items={[
            { label: "CSV", value: 0 },
            { label: "PDF", value: 1 },
          ]}
          defaultOption={{ label: "CSV", value: 0 }}
        />
      </div>
      <div>
        <Button
          className={className(cls.button, cls.exportBtn)}
          onClick={() => {
            onClickExport(format);
            setFormat("CSV");
            handleClose();
          }}
        >
          EXPORT
        </Button>
      </div>
      <div>
        <Button
          className={className(cls.button, cls.cancelBtn)}
          onClick={handleClose}
        >
          CANCEL
        </Button>
      </div>
    </Modal>
  );
};
export default AssessmentUpload;
